import { render, staticRenderFns } from "./associazioneStatiPolizza.vue?vue&type=template&id=83302d78&"
import script from "./associazioneStatiPolizza.vue.ts?vue&type=script&lang=ts&"
export * from "./associazioneStatiPolizza.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports